/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Esgile',
        title: 'CEO',
        text: "Working with Phethani was an absolute pleasure. Their front-end skills are top-notch, and they transformed our website into a user-friendly masterpiece. Their attention to detail and dedication to creating a seamless user experience is truly remarkable.",
        image: boy2
    },
    {
        id: 2,
        name: 'Moses Mukwevho',
        title: 'Backend Developer',
        text: "Phethani is a true front-end wizard! They took our design concepts and turned them into a stunning, responsive website. Their ability to bring creative ideas to life while maintaining the site's performance is truly impressive.",
        image: girl2
    },
    {
        id: 3,
        name: 'Rotondwa',
        title: 'Lawyer',
        text: "I can't recommend Phethani enough! They not only improved our website's performance but also gave it a modern, sleek look. Their expertise in HTML, CSS, and JavaScript is evident in the flawless user interface they created for us.",
        image: girl1
    },
    {
        id: 4,
        name: 'Nicholas Mamali',
        title: 'Frontend Developer',
        text: "Working with Phethani was a game-changer for our online presence. Their front-end development skills elevated our website's aesthetics and functionality to a whole new level. They are the go-to developer for anyone seeking excellence.",
        image: boy1
    },
    {
        id: 5,
        name: 'Mushe Group',
        title: 'Founder',
        text: "Phethani is a front-end genius! They took our project and exceeded our expectations. Their ability to turn complex designs into pixel-perfect web pages is unmatched. We're thrilled with the results.",
        image: girl3
    },
    {
        id: 6,
        name: 'Makananise Ndivho',
        title: 'Sales Excecutive',
        text: "We were fortunate to have Phethani on our team. Their front-end development skills transformed our website into a user-friendly, visually stunning platform. Their commitment to delivering high-quality work is commendable.",
        image: boy3
    }
]

